import type { Dispatch, FunctionComponent, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";

type ContextValue = {
  currentAgendaId?: string;
  setCurrentAgendaId?: Dispatch<SetStateAction<string>>;
  setShowEmptyAgenda?: Dispatch<SetStateAction<boolean>>;
  showEmptyAgenda?: boolean;
};

type Props = {
  children: ReactNode;
};

const NewsAgendaContext = createContext<ContextValue>({});

export const NewsAgendaContextProvider: FunctionComponent<Props> = ({ children }) => {
  const [currentAgendaId, setCurrentAgendaId] = useState("");
  const [showEmptyAgenda, setShowEmptyAgenda] = useState(false);
  return (
    <NewsAgendaContext.Provider
      value={{
        currentAgendaId,
        setCurrentAgendaId,
        setShowEmptyAgenda,
        showEmptyAgenda,
      }}
    >
      {children}
    </NewsAgendaContext.Provider>
  );
};

export const useNewsAgendaContext = () => useContext(NewsAgendaContext);
